import React from 'react';
import { Trash2 } from 'lucide-react';
import type { ChatHistoryEntry } from '../types';

interface ChatHistoryDropdownProps {
  chatHistory: ChatHistoryEntry[];
  selectedHistoryId: string | null;
  onLoadHistory: (entry: ChatHistoryEntry) => void;
  onDeleteHistory: (id: string, e: React.MouseEvent) => void;
}

export const ChatHistoryDropdown: React.FC<ChatHistoryDropdownProps> = ({
  chatHistory,
  selectedHistoryId,
  onLoadHistory,
  onDeleteHistory,
}) => {
  return (
    <div data-history-dropdown className="absolute top-14 right-4 z-50 w-[260px] bg-[#1c1c1e] border border-white/10 rounded-xl shadow-xl overflow-hidden flex flex-col">
      <div className="flex-1 max-h-[320px] overflow-y-auto custom-scrollbar p-1.5">
        {chatHistory.length === 0 ? (
          <div className="flex items-center justify-center py-6 text-slate-500 text-xs">暂无聊天记录</div>
        ) : (
          <div className="flex flex-col gap-0.5">
            {chatHistory.map((entry) => (
              <div
                key={entry.id}
                onClick={() => onLoadHistory(entry)}
                className={`group relative flex flex-col gap-0.5 px-3 py-2 rounded-lg cursor-pointer transition-colors duration-200 ${
                  selectedHistoryId === entry.id
                    ? 'bg-white/15'
                    : 'hover:bg-white/10'
                }`}
              >
                <span className="text-[10px] text-slate-500">{entry.date}</span>
                <div className="flex items-center justify-between">
                  <span className="text-[12px] font-medium text-white/90 truncate pr-6">{entry.topic}</span>
                  <button
                    onClick={(e) => onDeleteHistory(entry.id, e)}
                    className="absolute right-2 top-1/2 -translate-y-1/2 p-1 rounded-md text-slate-500 hover:text-rose-400 hover:bg-rose-400/10 opacity-0 group-hover:opacity-100 transition-all"
                    title="删除"
                  >
                    <Trash2 size={11} />
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
